import {
    /** FETCH APPLICATION  */
    FETCH_PAGINGAPPLICATIONSCAREPROVIDER_FULFILLED,
    FETCH_PAGINGAPPLICATIONSCAREPROVIDER_REJECTED,
    FETCH_PAGINGAPPLICATIONSCAREPROVIDER_PENDING,
    RESET_PAGINGAPPLICATIONSCAREPROVIDER
} from "../../actions/v3/pagingApplicationsCareProvider";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PAGINGAPPLICATIONSCAREPROVIDER_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_PAGINGAPPLICATIONSCAREPROVIDER_FULFILLED:
            return {
                ...state,
                pagingApplicationsCareProvider: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_PAGINGAPPLICATIONSCAREPROVIDER_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_PAGINGAPPLICATIONSCAREPROVIDER:
            return {
                initialState,
                done: false,
                error: false,
            };
        default:
            return state;
    }
};